import { Shield, Server, Database, Lock, FileCheck } from "lucide-react";

export default function SecuritySection() {
  const features = [
    { icon: Server, text: "Roda localmente" },
    { icon: Database, text: "Não depende de servidor externo" },
    { icon: Lock, text: "Não coletamos dados operacionais" },
    { icon: Shield, text: "Controle total sob sua empresa" },
    { icon: FileCheck, text: "Conformidade com LGPD" },
  ];

  return (
    <section
      id="security"
      className="relative py-16 md:py-32 bg-[#0F1115]"
      data-testid="security-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Proteção de Dados
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Segurança e <span className="text-[#F59E0B]">Controle</span>
          </h2>
        </div>

        {/* Security Features */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 bg-[#0F1115] rounded-sm border border-[#2A2F38]"
                  data-testid={`security-feature-${index}`}
                >
                  <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                    <feature.icon className="h-5 w-5 text-[#F59E0B]" />
                  </div>
                  <span className="text-[#E5E7EB] font-medium">{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 pt-8 border-t border-[#2A2F38]">
              <p className="text-[#F59E0B] text-lg font-medium text-center mb-6">
                Seus dados não saem da sua estrutura.
              </p>
              
              <div className="bg-[#0F1115] border border-[#2A2F38] rounded-sm p-6 mt-6">
                <p className="text-sm text-[#9CA3AF] mb-3">
                  O KpAction opera integralmente de forma local no dispositivo do usuário.
                </p>
                <p className="text-sm text-[#9CA3AF] mb-3">
                  Nenhum dado operacional é transmitido para servidores externos.
                </p>
                <p className="text-sm text-[#9CA3AF] mb-3">
                  Nenhum dado operacional é coletado, armazenado ou acessado pela EVIDENTIA TECNOLOGIA LTDA.
                </p>
                <p className="text-sm text-[#E5E7EB] font-medium">
                  Toda a informação permanece sob controle exclusivo da empresa usuária.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
